<template>
  <el-container>
    <!-- 头部 -->
    <el-header>
      <div class="logo">
        <div class="header_logo" style="display: flex;">
          <el-tooltip class="item" effect="dark" content="鲸鱼甄选" placement="top-start">
            <img style="border-radius: 4px" src="../assets/images/deepseek.png" alt="鲸鱼甄选"  />

          </el-tooltip>

          <div style="font-size: 24px; margin-left: 10px; color:#1891ff;font-weight: 600 ">鲸鱼甄选</div>
        </div>
        <div class="toggle-button ml20" @click="togleCollapse">
          <i class="el-icon-s-fold f20" ref="icon"></i>
        </div>
      </div>
      <div class="user flex align-center">



        <div class="userInfo">
          <span class="vm">{{ loginName }}</span>
        </div>

        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-more "></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="setting">账户设置</el-dropdown-item>
            <el-dropdown-item command="logout">登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <!-- 主体 -->
    <el-container>
      <!-- 侧边栏 -->
<!--      <el-aside :width="isCollapse ? '64px' : '230px'">-->
<!--        <el-menu unique-opened :collapse="isCollapse" :collapse-transition="false" router :default-active="activeNav"-->
<!--                 background-color="#ffffff" text-color="#000" active-text-color="#409eff" :index="item.link"-->
<!--                 v-for="item in menuList" :key="item.menuCode">-->
<!--          &lt;!&ndash; 一级菜单  &ndash;&gt;-->
<!--          <el-menu-item :index="item.link" @click="stairSaveNavState('/' + item.link, item)"-->
<!--                        v-if="!item.childrens || item.childrens.length == 0">-->
<!--            <el-image :src="item.iconUrl" style="width:15px;height:15px;margin-right:10px"></el-image>-->
<!--            <span slot="title">{{ item.name }}</span>-->
<!--          </el-menu-item>-->

<!--          &lt;!&ndash; 有二级的菜单 &ndash;&gt;-->
<!--          <el-submenu v-if="item.childrens && item.childrens.length" :index="item.link">-->
<!--            <template slot="title">-->
<!--              <el-image :src="item.iconUrl" style="width:15px;height:15px;margin-right:10px"></el-image>-->
<!--              <span>{{ item.name }}</span>-->
<!--            </template>-->
<!--            <el-menu-item :index="i.link" @click="stairSaveNavState(i.link, i)" v-for="i in item.childrens"-->
<!--                          :key="i.menuCode">-->
<!--              <template slot="title">-->
<!--                &lt;!&ndash; <el-image :src="i.iconUrl" style="width:20px;height:20px;margin-right:10px"></el-image> &ndash;&gt;-->
<!--                <span>{{ i.name }}</span>-->
<!--              </template>-->
<!--            </el-menu-item>-->
<!--          </el-submenu>-->
<!--        </el-menu>-->
<!--      </el-aside>-->


      <el-menu router  :default-active="activeNav"  :unique-opened="true"  class="el-menu-vertical-demo" text-color="#000" active-text-color="#409eff" :collapse="false">
        <template v-for="(item,index) in menuList" >
          <el-submenu style="width: 200px" :index="item.menuCode">
            <template slot="title">
              <el-image
                :src="item.iconUrl"
                style="width:15px;height:15px;margin-right:10px"
              ></el-image>
              {{item.name}}
            </template>

            <el-menu-item-group >
<!--              <span slot="title">{{item.name}}</span>-->
              <el-menu-item :index="ele.link" @click="stairSaveNavState(ele.link, ele)" v-for="ele in item.childrens">{{ele.name}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </template>
      </el-menu>




      <!-- 内容主体 -->
      <el-main class="main-center">
        <div class="template-tabs" style="margin-left:10px">
          <el-tabs v-model="activeTab" type="card" closable @tab-click="tabClick" @tab-remove="removeTab">
            <el-tab-pane :key="item.name" v-for="item in tabsItem" :label="item.title" :name="item.name">
            </el-tab-pane>
          </el-tabs>
          <router-view class="routerView_class"></router-view>
        </div>
      </el-main>
    </el-container>

    <div id="loader-wrapper" v-show="showLoading">
      <div id="loader"></div>
      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
      <div class="load_title">
        正在载入,请耐心等待..
        <br />
        <!-- <span>V1.0</span> -->
      </div>
    </div>
  </el-container>
</template>



<script>
export default {
  data() {
    return {
      firstIndex: 0,
      currFirstItem: {},
      // 左侧菜单数据
      menuList: [

      ],
      tabsItem: [],
      // 消息
      messageObj: {},
      iconObj: {
        1: "el-icon-s-home",
        2: "iconfont icon-user",
        3: "iconfont icon-tijikongjian",
        4: "iconfont icon-shangpin",
        5: "iconfont icon-danju",
        6: "iconfont icon-baobiao",
        7: "iconfont icon-baobiao",
        8: "iconfont icon-danju",
      },
      // 默认不折叠
      isCollapse: false,
      // 被激活导航地址
      activePath: "/index",
      loginName: "",
      showLoading: true,
      imageUrl: "",
      activeTab: "1", //默认显示的tab
      tabIndex: 1, //tab目前显示数
    };
  },
  created() {
    // this.getMenuList()
    this.tabsItem = JSON.parse(sessionStorage.getItem("tabsItem")) || []
    this.activeTab = sessionStorage.getItem("activeTab") || ''
    // this.name=JSON.parse(localStorage.getItem('userInfo')).name
    this.activePath = window.sessionStorage.getItem("activePath");
    this.loginName = localStorage.getItem("loginName");
    // this.getUserInfo();
  },
  computed: {
    setHeight() {
      return document.documentElement.clientHeight - 65;
    },
    activeNav() {
      //当前激活的导航
      return this.$route.path;
    },
  },
  mounted() {
    this.getMenuList();
  },
  methods: {
    switchCommand(command) {
      if (command == "exChange") {
        this.$router.push("/exChange");
      } else if (command == 'singleBusinessNum') {
        this.$router.push("/auditBusinesstwo");
      } else if (command == 'chainBusinessNum') {
        this.$router.push("/auditBusinessOne");
      }
    },
    choiceFirstMu(item, i) {
      this.firstIndex = i
      this.currFirstItem = item
      this.isCollapse = false
    },
    addTab(menu) { // object
      console.log(' //判断是否已经存在了', this.tabsItem, 'ss')
      //判断是否已经存在了
      let menuExsit = false
      for (var item of this.tabsItem) {
        if (menu.menuCode == item.menuCode) {
          menuExsit = true;
          this.activeTab = item.name;
          this.$router.push({ path: menu.link });
        }
      }
      if (!menuExsit) {
        //不存在
        let newTabName = menu.name;
        this.tabsItem.push({
          title: menu.name,
          name: menu.name,
          link: menu.link,
          menuCode: menu.menuCode,
        });
        this.activeTab = newTabName;
        this.$router.push({ path: menu.link });
      }
      sessionStorage.setItem("tabsItem", JSON.stringify(this.tabsItem))
      sessionStorage.setItem("activeTab", this.activeTab)
    },
    removeTab(targetName) {
      let tabs = this.tabsItem;
      let activeName = this.activeTab;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.activeTab = activeName;
      this.tabsItem = tabs.filter((tab) => tab.name !== targetName);
    },
    tabClick(tab) {
      let path = '';
      let menuName = tab.$options.propsData.name;
      for (var item of this.tabsItem) {
        if (menuName == item.name) {
          path = item.link;
        }
      }
      this.$router.push({ path: path });
    },

    async getMenuList () {
      // var that = this
      var loginName = localStorage.getItem('loginName')
      console.log('index loginName', this.$store.state.main.showItemMuName)
      // 存储超时，跳转到登陆页
      if (loginName == null || loginName == '') {
        // 用户名不存在跳转登陆
        this.$router.push({ path: '/login' })
        return
      }

      const res = await this.$http.post('/menuInfo/getUserMenu2', {
        loginName: loginName
      })

      if(res.data.code===200){
        this.menuList = res.data.data
        this.currFirstItem = this.menuList.length ? this.menuList[0] : {}
        this.showLoading = false
        // that.showItemMuName = res.data.data[0].name;
        let name = sessionStorage.getItem('showItemMuName')
        if (name) {
          this.showItemMuName = name
        } else {
          this.showItemMuName = res.data.data[0].name
        }
        this.activePath = sessionStorage.getItem('activePath')
      }else {
        console.log(res.data.message,277)
        // this.showLoading = false
        this.$message.error(res.data.message)
      }
    },

    getLocalStorage(key) {
      // 取出对象
      let item = localStorage.getItem(key);
      // 先将拿到的试着进行json转为对象的形式
      try {
        item = JSON.parse(item);
      } catch (error) {
        // eslint-disable-next-line no-self-assign
        item = item;
      }
      // 如果有startTime的值，说明设置了失效时间
      if (item && item.startTime) {
        let date = new Date().getTime();
        // 如果大于就是过期了，如果小于或等于就还没过期
        if (date - item.startTime > item.expires) {
          localStorage.removeItem(name);
          return "";
        } else {
          return item.value;
        }
      } else {
        return "";
      }
    },
    // 菜单的折叠与展开
    togleCollapse() {
      // console.log(this.$refs)
      if (this.$refs.icon.className == "el-icon-s-fold f20") {
        this.$refs.icon.className = "el-icon-s-unfold f20";
      } else {
        this.$refs.icon.className = "el-icon-s-fold f20";
      }
      this.isCollapse = !this.isCollapse;
    },
    // 保存连接的激活地址
    stairSaveNavState(activePath, menu) {
      console.log(activePath, menu, 'menuuuuuuuuuu')
      //主窗口添加显示
      this.activePath = activePath
      this.addTab(menu);
    },
    // 监听下拉菜单子选项点击事件
    handleCommand(command) {
      //this.$message("click on item " + command);
      if (command == "logout") {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("loginName");
        this.$router.push("/login");
      } else {
        this.$router.push("/myAccountView");
      }
    },

    // //获取个人信息
    // async getUserInfo() {
    //   let res = await this.$http.post("/userInfo/queryOne", { loginName: this.loginName })
    //   if (res.data.code == 200) {
    //     this.imageUrl = res.data.data.logo;
    //   }
    // },

  },
};
</script>

<style lang="less" scoped>
.messageBox {
  position: relative;

  .numberOrder {
    display: block;
    width: 10px;
    height: 10px;
    position: absolute;
    top: -5px;
    right: -5px;
    color: #F56C6C;
    border: 1px solid #F56C6C;
    border-radius: 50%;
    font-size: 8px;
    text-align: center;
    line-height: 10px;
  }
}

.s-content {
  img {
    width: 15px;
    height: 15px;
    margin-right: 8px;
  }
}

.f-menu {
  cursor: pointer;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
}

.f-menu-active {
  cursor: pointer;
  width: 56px;
  height: 56px;
  background: #fff;
  flex-shrink: 0;
}

.f-img {
  width: 22px;
  height: 22px;
}

.s-menu-t {
  color: #0094efff;
  font-size: 16px;
  margin: 0 13px 5px 16px;
  min-height: 50px;
  position: relative;
  line-height: 50px;
  border-bottom: 1px solid #eff4f5ff;
  overflow: hidden;
}

/deep/.el-menu-item.is-active {
  // width: 160px;
  width: 100%;
  color: #ffffff;
  box-sizing: border-box;
  //background-color: #37588a !important;
  // color: #0086d9;
  // background: #acdefd;
  // border-right: 2px solid #0086d9;
}

/deep/.el-submenu .el-menu-item {
  //min-width: 160px;
  box-sizing: border-box;
  //background-color: #28292b;
}

/deep/.el-submenu.is-active .el-submenu__title {
  // color: #0086d9;
  //color: #37588a;
}

///deep/.el-submenu.is-active .el-submenu__title i {
//  // color: #0086d9;
//  // color: #37588a;
//  color: #ffffff;
//}

.el-container {
  height: 100%;
  overflow-y: hidden;
}

.el-header {
  //background-color: #28292b;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;

  .logo {
    display: flex;
    align-items: center;
    height: 100%;

    .header_logo {
      display: flex;
      align-items: center;
      width: 230px;
      //background-color: #336084;
      height: 100%;
      //justify-content: center;
      cursor: pointer;
      margin-left: 10px;

      img {
        height: 25px;
      }
    }
  }

  .user {
    margin-right: 28px;

    .userInfo {
      margin-right: 40px;
      color: #000000;
      font-size: 13px;
    }

    >.el-dropdown-menu {
      top: 57px !important;
    }
  }
}

.el-aside {
  //background-color: #28292b;

  .el-menu {
    border: none;
  }
}

/deep/.el-main {
  padding: 0;
  height: 100%;
  //background-color: #eef1f6;
  background-color: #ffffff;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  // 鼠标放上去变成小手
  cursor: pointer;
}

html,
body,
#app {
  height: 100%;
  margin: 0px;
  padding: 0px;
}

.chromeframe {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

#loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
}

#loader {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 120px;
  height: 120px;
  margin: -60px 0 0 -60px;
  border-radius: 50%;
  border: 3px solid transparent;
  /* COLOR 1 */
  border-top-color: #fff;
  -webkit-animation: spin 2s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -ms-animation: spin 2s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -moz-animation: spin 2s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -o-animation: spin 2s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  animation: spin 2s linear infinite;
  /* Chrome, Firefox 16+, IE 10+, Opera */
  z-index: 1001;
}

#loader:before {
  content: '';
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 3px solid transparent;
  /* COLOR 2 */
  border-top-color: #fff;
  -webkit-animation: spin 3s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -moz-animation: spin 3s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -o-animation: spin 3s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -ms-animation: spin 3s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  animation: spin 3s linear infinite;
  /* Chrome, Firefox 16+, IE 10+, Opera */
}

#loader:after {
  content: '';
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #fff;
  /* COLOR 3 */
  -moz-animation: spin 1.5s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -o-animation: spin 1.5s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -ms-animation: spin 1.5s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  -webkit-animation: spin 1.5s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  animation: spin 1.5s linear infinite;
  /* Chrome, Firefox 16+, IE 10+, Opera */
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(0deg);
    /* IE 9 */
    transform: rotate(0deg);
    /* Firefox 16+, IE 10+, Opera */
  }

  100% {
    -webkit-transform: rotate(360deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(360deg);
    /* IE 9 */
    transform: rotate(360deg);
    /* Firefox 16+, IE 10+, Opera */
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(0deg);
    /* IE 9 */
    transform: rotate(0deg);
    /* Firefox 16+, IE 10+, Opera */
  }

  100% {
    -webkit-transform: rotate(360deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(360deg);
    /* IE 9 */
    transform: rotate(360deg);
    /* Firefox 16+, IE 10+, Opera */
  }
}

#loader-wrapper .loader-section {
  position: fixed;
  top: 0;
  width: 51%;
  height: 100%;
  background: #7171c6;
  /* Old browsers */
  z-index: 1000;
  -webkit-transform: translateX(0);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateX(0);
  /* IE 9 */
  transform: translateX(0);
  /* Firefox 16+, IE 10+, Opera */
}

#loader-wrapper .loader-section.section-left {
  left: 0;
}

#loader-wrapper .loader-section.section-right {
  right: 0;
}

/* Loaded */
.loaded #loader-wrapper .loader-section.section-left {
  -webkit-transform: translateX(-100%);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateX(-100%);
  /* IE 9 */
  transform: translateX(-100%);
  /* Firefox 16+, IE 10+, Opera */
  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.loaded #loader-wrapper .loader-section.section-right {
  -webkit-transform: translateX(100%);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateX(100%);
  /* IE 9 */
  transform: translateX(100%);
  /* Firefox 16+, IE 10+, Opera */
  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.loaded #loader {
  opacity: 0;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}

.loaded #loader-wrapper {
  visibility: hidden;
  -webkit-transform: translateY(-100%);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateY(-100%);
  /* IE 9 */
  transform: translateY(-100%);
  /* Firefox 16+, IE 10+, Opera */
  -webkit-transition: all 0.3s 1s ease-out;
  transition: all 0.3s 1s ease-out;
}

/* JavaScript Turned Off */
.no-js #loader-wrapper {
  display: none;
}

.no-js h1 {
  color: #222222;
}

#loader-wrapper .load_title {
  font-family: 'Open Sans';
  color: #fff;
  font-size: 18px;
  width: 100%;
  text-align: center;
  z-index: 9999999999999;
  position: absolute;
  top: 60%;
  opacity: 1;
  line-height: 30px;
}

#loader-wrapper .load_title span {
  font-weight: normal;
  font-style: italic;
  font-size: 13px;
  color: #fff;
  opacity: 0.5;
}

// @media (max-width: 1366px) {
//    #loader {
//     top: 45%;
//   }
// }
.news {
  margin-right: 20px;

  img {
    position: relative;
    top: 3px;
    width: 20px;
    height: 20px;
  }

  span {
    color: #fff;
    font-size: 600;
    font-size: 13px;
    margin-left: 5px;
    position: relative;
    top: -2px;
  }
}

/deep/ .el-menu-item {
  // background: #e4e7ed;
  //background-color: #37588a;
}

/deep/ .f-menu-active {
  background: #29d;
}

///deep/.el-submenu__icon-arrow {
//  font-size: 16px;
//  color: #ffffff;
//}

.template-tabs{
  display: flex;
  flex-direction: column;
  height: 100%;
}
.routerView_class{
  flex: 1;
}

::v-deep .el-menu--collapse  {
  width: 50px !important;
}

::v-deep .el-menu {
  border-right: none !important;
}

::v-deep .el-menu-item-group__title  {
  padding: 0px !important;
}
</style>
